import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/cricketCard.css';

// constants
import {
    ALL_CRICKET_MARKETS,
    MATCH_WINNER,
    TOTAL_FOUR_IN_MATCH,
    TOTAL_SIXES_IN_MATCH,
    TOTAL_BOUNDARIES_IN_MATCH,
    FIRST_TEAM_TOTAL_RUNS,
    UNDER_OVER,
    FIRST_TEAM_RUNS_OFF_FIRST_BALL,
    FIRST_TEAM_WICKET_LOST,
    FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE
} from '../constants/marketTypes';
// helpers
import {getMarketsByCode} from '../helpers/marketHelpers';
import {getText} from '../../../../../helpers/localization';
// containers
import Accordion from '../containers/accordion';
// components
import FirstTeamRunsOffFirstBall from '../components/firstTeamRunsOffFirstBall';
import UnderOver from '../components/underOver';
import FirstTeamWicketLost from '../components/firstTeamWicketLost';

import {showBetSummary} from '../../../helpers/betHelpers';
import OverlayContainer from './../../../containers/overlayContainer';
import {collapseAllMarkets, expandAllMarkets,expandCollapseMarket} from "../actions/marketsActions";
import UnderOverCombine from "../components/underOverCombine";
import WinDrawWin from "../components/winDrawWin";

const mapStateToProps = (state, ownProps) => {
    return {
        selectedGameIndex: state.vpp.selectedGameIndex,
        games: state.vpp.games,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        betHistoryBets: state.vpp.betHistoryBets,
        cricketMarketsExpanded: state.vpp.cricketMarketsExpanded,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
        nextEventsTimeStamp: state.vpp.nextEventsTimeStamp,
        channelEventBets: state.vpp.channelEventBets
    };
};

class CricketCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            games: storeData.vpp.games,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            betHistoryBets: storeData.vpp.betHistoryBets,
            cricketMarketsExpanded: storeData.vpp.cricketMarketsExpanded,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
            nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
            channelEventBets: storeData.vpp.channelEventBets
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                games: storeData.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                betHistoryBets: storeData.vpp.betHistoryBets,
                cricketMarketsExpanded: storeData.vpp.cricketMarketsExpanded,
                noMoreBetsEventList: storeData.vpp.noMoreBetsEventList,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                channelEventBets: storeData.vpp.channelEventBets,
            });
        }
    }

    _generateMarketUI(marketCode, selectedEvent, key) {
        let store = this.props.store;
        let marketList = selectedEvent.markets;
        let marketUI;
        let markets = getMarketsByCode(marketCode, marketList);
        let homeTeam = getText(this.state.events[this.state.selectedEventIndex].teamOne, store);
        let awayTeam = getText(this.state.events[this.state.selectedEventIndex].teamTwo, store);
        let marketName = getText(marketCode.name, store, [homeTeam, awayTeam]);
        let content;
        if (markets.length > 0) {
            switch (marketCode) {
                case MATCH_WINNER:
                    content =  (
                        <WinDrawWin callbacks={() => undefined} markets={markets} store={store}
                                    selectedEvent={selectedEvent} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;

                case TOTAL_FOUR_IN_MATCH:
                    content =  (
                        <UnderOver callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (<Accordion marketLabel={marketName} store={store} key={key} index={key}
                                           content={content}/>);
                    break;

                case TOTAL_SIXES_IN_MATCH:
                        content =  (
                            <UnderOver callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                        marketUI = (<Accordion marketLabel={marketName} store={store} key={key} index={key}
                                               content={content}/>);

                    break;
                case TOTAL_BOUNDARIES_IN_MATCH:
                    content =  (
                        <UnderOver callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (<Accordion marketLabel={marketName} store={store} key={key} index={key}
                                           content={content}/>);

                    break;
                case FIRST_TEAM_TOTAL_RUNS:
                    content =  (
                        <UnderOver callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (<Accordion marketLabel={marketName} store={store} key={key} index={key}
                                           content={content}/>);

                    break;

                case UNDER_OVER:
                    content =  (
                        <UnderOverCombine callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (<Accordion marketLabel={getText('FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER', store, [homeTeam, awayTeam])} store={store} key={key} index={key}
                                           content={content}/>);

                    break;

                case FIRST_TEAM_RUNS_OFF_FIRST_BALL:
                    content = (<FirstTeamRunsOffFirstBall callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;


                case FIRST_TEAM_WICKET_LOST:
                    content = (<FirstTeamWicketLost callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;
                case FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE:
                    content = (<FirstTeamRunsOffFirstBall callbacks={() => undefined} markets={markets} store={store} key={key}/>);
                    marketUI = (
                        <Accordion marketLabel={marketName} store={store} key={key} index={key} content={content}/>);
                    break;

                default:
                    break;
            }
        }
        return marketUI;
    }
    _toggleMarkets(){
        if (window.innerWidth < 950) {
            this.props.store.dispatch(collapseAllMarkets());
            this.props.store.dispatch(expandCollapseMarket(0))
        }
        else{
            this.props.store.dispatch(expandAllMarkets());
        }
    }
    componentDidMount() {
        this._toggleMarkets();
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];

        let marketsUI;
        if (selectedEvent !== undefined && selectedEvent.markets && selectedEvent.markets.length) {
            marketsUI = ALL_CRICKET_MARKETS.map((mkt, index) => this._generateMarketUI(mkt, selectedEvent, index));
        }

        if (showBetSummary(this.props.showLoadingOverlay, selectedGame, selectedEvent, storeData.vpp.noMoreBetsEventList, this.state)) {
            marketsUI = '';
        }
        let overlay = <OverlayContainer store={this.props.store} showLoadingOverlay={this.props.showLoadingOverlay}/>

        return (
            <div id={'football_card'} className={style.mainContainer}>
                <div className={style.footballCard}>{overlay}{marketsUI}</div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(CricketCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/containers/cricketCard.js